(() => {
  const initAboutSection = (root) => {
    if (!root || root.dataset.aboutInitialized === 'true') return;
    root.dataset.aboutInitialized = 'true';

    const revealItems = [...root.querySelectorAll('[data-about-reveal]')];
    root.classList.add('is-ready');

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(
        (entries, instance) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            instance.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    root.querySelectorAll('[data-about-video]').forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          const videoId = button.dataset.videoId;
          if (!videoId) return;

          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
          iframe.title = button.getAttribute('aria-label')?.replace(/^Reproducir vídeo:\s*/i, '') || 'Vídeo de Mínima Organics';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.setAttribute('loading', 'eager');
          button.replaceWith(iframe);
        },
        { once: true }
      );
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('.minima-about-v8').forEach(initAboutSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
